<template>
  <dx-modal title="Lista de planos de saúde" :value="true" @input="close">
    <div class="loading loading-lg mt-2" v-if="loading" />
    <template v-else>
      <div class="columns">
        <div class="column col-12 form-group">
          <label class="form-label">Pesquisar</label>
          <div class="input-group">
            <input
              type="text"
              class="form-input"
              id="search"
              v-model="filterSearch"
              v-focus
              placeholder="Digite parte do nome..."
            >
            <button
              class="btn btn-neutral btn-icon btn-action input-group-btn"
              :disabled="loading"
              :class="{loading}"
            ><fa-icon :icon="['fal', 'search']" />
            </button>
          </div>
        </div>
      </div>
      <div class="empty mt-2"
           v-if="data.items.length === 0">
        <div class="empty-icon">
          <fa-icon :icon="['fal', 'info-circle']" size="2x"/>
        </div>
        <p class="empty-title h6">Planos de saúde</p>
        <p class="empty-subtitle">
          Nenhum plano de saúde cadastrado.
        </p>
      </div>
      <template v-else>
        <div class="empty mt-2"
             v-if="filteredInsurancePlans.length === 0">
          <div class="empty-icon">
            <fa-icon :icon="['fal', 'info-circle']" size="2x"/>
          </div>
          <p class="empty-title h6">Planos de saúde</p>
          <p class="empty-subtitle">
            Nenhum plano de saúde encontrado com este nome.
          </p>
        </div>
        <table class="table table-hover">
          <thead>
          <tr>
            <th class="text-secondary" style="width: 40px">
              <label class="form-checkbox">
                <input type="checkbox"
                       @change="selectAllInsurancePlans"
                       :checked="getInsurancePlanSelected"
                       :indeterminate.prop="getInsurancePlanSelected === null">
                <i class="form-icon"></i>
              </label>
            </th>
            <th>Nome</th>
            <th>Tipo</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, i) in filteredInsurancePlans" :key="i">
            <td class="text-center">
              <label class="form-checkbox">
                <input type="checkbox" v-model="item.selected">
                <i class="form-icon" />
              </label>
            </td>
            <td>
            <span class="hover-link c-hand" @click="selected(item)">
              {{ item.customName }}
            </span>
            </td>
            <td>{{ getName(item.plan.type) }}</td>
          </tr>
          </tbody>
        </table>
      </template>
    </template>
    <template v-slot:footer>
      <button
        class="btn btn-primary btn-icon btn-icon-left mr-2"
        v-if="hasSelected"
        @click="addMultiSelected">
        <fa-icon :icon="['fal', 'check-double']" />
        Adicionar selecionados
      </button>
      <button class="btn" @click="close">Sair</button>
    </template>
  </dx-modal>
</template>

<script>
import fuzzy from 'fuzzy';
import { getName } from 'src/data/insurance-types';
import formMixin from '@/mixins/form';

export default {
  mixins: [formMixin],
  data() {
    return {
      loading: false,
      filterSearch: '',
      getName,
      data: this.blankData(),
    };
  },
  mounted() {
    this.load();
  },
  computed: {
    hasSelected() {
      return this.data.items.some(({ selected }) => selected);
    },
    getInsurancePlanSelected() {
      if (!this.data.items || this.data.items.length === 0) {
        return false;
      }

      const selected = this.data.items.filter(item => item.selected);

      if (selected.length === 0) {
        return false;
      }
      if (selected.length === this.data.items.length) {
        return true;
      }
      return null;
    },
    filteredInsurancePlans() {
      let insurancePlans = this.data.items;

      if (this.filterSearch.trim()) {
        const results = fuzzy.filter(this.filterSearch, insurancePlans, {
          extract: (el) => {
            if (el.name) {
              return this.removeAccentuation(el.name);
            }
            return '';
          },
        });
        insurancePlans = results.map(({ original }) => original);
      }

      return insurancePlans;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    load() {
      this.loading = true;
      const params = {
        limit: 0,
        active: true,
      };
      return this.$http.get('/insurance-plans', { params })
        .then(({ data }) => {
          this.data = data;
        })
        .catch(() => {
          this.$toast.error('Ocorreu um erro ao carregar os dados!');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    selectAllInsurancePlans(e) {
      this.data.items.forEach((item) => {
        item.selected = e.target.checked;
      });
    },
    selected(item) {
      this.$emit('selected', [item]);
    },
    addMultiSelected() {
      this.$emit('selected', this.data.items.filter(({ selected }) => selected));
    },
    blankData() {
      return {
        items: [],
        hasMore: false,
      };
    },
  },
};
</script>
